import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

const UpdateGroupMaster = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const groupData = location.state?.groupData || {};
  const [editableData, setEditableData] = useState({});
  const [mainGroups, setMainGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  useEffect(() => {
    if (!groupData || Object.keys(groupData).length === 0) {
      showToast.error("No data provided for editing.");
      navigate("/GroupMaster");
    } else {
      setEditableData(groupData);
    }

    fetchDropdownData();
  }, []);

  // Fetch all groups for dropdown
  const fetchDropdownData = async () => {
    setLoading(true);
    setMainGroups([]);

    try {
      const response = await fetch(`${BASE_API_URL}/groups`);
      const data = await response.json();
      setMainGroups(data.mainGroups || []);
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
      showToast.error("Failed to load dropdown data");
    } finally {
      setLoading(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveChanges = async (e) => {
    if (e) e.preventDefault();
    if (loading) return;

    if (!editableData.GroupNAME || !editableData.MAINGroup) {
      showToast.error("Please fill out all required fields.");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        GroupNAME: editableData.GroupNAME,
        MAINGroup: editableData.MAINGroup,
      };

      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/groups/${editableData.GroupCODE}`,
        data: payload,
        module: "GroupMaster",
        action: "E",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status >= 200 && res.status < 300) {
        showToast.save("Group updated successfully!");
        setTimeout(() => navigate("/GroupMaster"), 1200);
      } else {
        const errorData = res.data || {};
        showToast.error(errorData.error || "Failed to update group");
      }
    } catch (err) {
      console.error("Update error:", err);
      showToast.error(err.message || "Failed to update group");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Update Group Master</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/GroupMaster">Group Master</Link>
            <span>/</span>
            <span>Update</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Group Details</h5>
        </div>

        <form onSubmit={handleSaveChanges}>
          <div className="update_ledger_grid">
            {/* Group Name */}
            <div className="update_ledger_field">
              <label htmlFor="GroupNAME">
                Group Name <span className="required">*</span>
              </label>
              <input
                id="GroupNAME"
                type="text"
                placeholder="Enter Group Name"
                name="GroupNAME"
                required
                value={editableData.GroupNAME || ""}
                onChange={handleInputChange}
              />
            </div>

            {/* Under Group (Dropdown) */}
            <div className="update_ledger_field">
              <label htmlFor="MAINGroup">
                Under Group <span className="required">*</span>
              </label>
              <select
                id="MAINGroup"
                name="MAINGroup"
                value={editableData.MAINGroup || ""}
                onChange={handleInputChange}
                required
              >
                <option value="">-- Select Under Group --</option>
                {mainGroups.map((g) => (
                  <option key={g.GroupCODE} value={g.GroupCODE}>
                    {g.GroupNAME}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/GroupMaster" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Updating..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateGroupMaster;
